import styles from "./Needhelp.module.css"

const NeedHelp = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>Need Help ?</h2>
          <p className={styles.description}>
            We aim to develop our own team, influence the community in all its aspects, and leave an impact locally,
            regionally and internationally.
          </p>
          <button className={styles.button}>CONTACT US</button>
        </div>
      </div>
    </section>
  )
}

export default NeedHelp

